<template>

    <div class="bg-dark text-white text-center d-none d-md-block info-bar">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center">
                <div class="align-self-stretch">
                    <template v-if="$page.props.currentRouteName !== 'home'">
                        <button type="button" class="btn btn-primary text-white p-2 text-nowrap h-100 rounded-0" id="menuDropdown" ref="menuDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-list"></i>
                            {{ __('Alle Kategorien') }}
                        </button>
                        <div class="dropdown-menu p-0" style="width: 300px">
                            <main-menu />
                        </div>
                    </template>
                </div>
                <div class="p-2 text-start">
                    <!--@todo zone-->
                    <div class="small">
                        Alle dargestellten Preise sind exklusive DENTAGEN-Konditionen <i class="bi bi-arrow-right-short"></i> sollten Sie Wünsche oder Fragen haben, melden Sie sich gerne direkt bei uns.
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import MainMenu from '@/shared/MainMenu';

    export default {
        props: [],
        components: {
            MainMenu,
        },
    }
</script>